import {AssetImageMap} from 'types/commons'
import {getCDNBaseUrl} from '../../../utils/commons/environment/EnvirontmentHelper'

export const IMAGE_ASSET = <T extends keyof AssetImageMap>(
  type: T,
  file: AssetImageMap[T],
) => `${getCDNBaseUrl()}/${type}/${file}`
